import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/shop/:category?/:brand?',
    name: 'shop',
    component: () => import('../views/ShopView.vue')
  },
  {
    path: '/install',
    name: 'install',
    component: () => import('../views/InstallView.vue')
  },
  {
    path: '/lifeshow',
    name: 'lifeshow',
    component: () => import('../views/LifeshowView.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/product/:data',
    name: 'product',
    component: () => import('../views/ProductView.vue')
  },
  {
    path: '/cart',
    name: 'cart',
    component: () => import('../views/CartView.vue')
  },
  {
    path: '/payment/:total',
    name: 'payment',
    component: () => import('../views/PaymentView.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
